import React, { useState } from "react";
import { Grid2 } from "@mui/material";
//styles
import styles from "./AccountSettings.module.scss";
import DisplaySettingsOutlinedIcon from "@mui/icons-material/DisplaySettingsOutlined";
import Dropdown from "../../../../../../../GlobalComponents/Dropdown/Dropdown";

const dropdownOptions = [
  { value: "OrganizationOverview", label: "Organization Overview" },
  // { value: "Dashboard", label: "Dashboard" },
  // { value: "CreateSite", label: "Create Site" },
  // { value: "Sites", label: "Sites" },
  // { value: "Blueprints", label: "Blueprints" },
  // { value: "Billing", label: "Billing" },
];

function AccountSettings() {
  const [value, setValue] = useState("OrganizationOverview");

  const handleSelect = (selectedOption) => {
    setValue(selectedOption);
  };

  return (
    <Grid2 className={styles.AccountSettingMainContainer}>
      <Grid2 className={styles.flexBox}>
        <Grid2 className={styles.Icon}>
          <DisplaySettingsOutlinedIcon className={styles.IconColor} />
        </Grid2>
        <Grid2 className={styles.Header}>Account Settings</Grid2>
      </Grid2>
      <Dropdown
        title="Default homepage"
        placeholder="Select your option"
        options={dropdownOptions}
        value={value}
        onSelect={handleSelect}
        // disabled={true}
      />
    </Grid2>
  );
}

export default AccountSettings;
